import { Link } from "react-router-dom";
import { useTheme } from "@/context/ThemeContext";

export default function Footer() {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <footer className={`border-t transition-colors duration-300 ${isDark ? "bg-[#111111] border-white/10" : "bg-[#f5f5f7] border-black/8"}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/5799cc79-ebf2-42bb-b3ff-edc4746d4641.png"
              alt="Complete AI Business Solutions"
              className="h-9 w-auto object-contain mb-4"
            />
            <p className={`text-sm leading-relaxed max-w-xs ${isDark ? "text-white/45" : "text-[#6e6e73]"}`}>
              End-to-end AI systems built for service businesses that want to scale.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className={`text-xs font-semibold tracking-widest uppercase mb-5 ${isDark ? "text-white/50" : "text-[#6e6e73]"}`}>Navigation</h4>
            <ul className="space-y-3">
              {[
                { label: "Home", path: "/" },
                { label: "Industries", path: "/industries" },
                { label: "Case Studies", path: "/case-studies" },
                { label: "Contact", path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className={`text-sm transition-colors duration-200 cursor-pointer ${isDark ? "text-white/45 hover:text-white" : "text-[#6e6e73] hover:text-[#1d1d1f]"}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h4 className={`text-xs font-semibold tracking-widest uppercase mb-5 ${isDark ? "text-white/50" : "text-[#6e6e73]"}`}>Get Started</h4>
            <p className={`text-sm leading-relaxed mb-5 ${isDark ? "text-white/45" : "text-[#6e6e73]"}`}>
              Ready to stop losing leads and start operating like a system?
            </p>
            <Link
              to="/contact"
              className={`inline-block px-6 py-3 text-sm font-semibold rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                isDark ? "bg-white text-[#0a0a0a] hover:bg-white/90" : "bg-[#1d1d1f] text-white hover:bg-[#1d1d1f]/85"
              }`}
            >
              Book Your AI Strategy Call
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className={`border-t pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 ${isDark ? "border-white/10" : "border-black/8"}`}>
          <p className={`text-xs ${isDark ? "text-white/25" : "text-[#6e6e73]/70"}`}>
            &copy; {new Date().getFullYear()} Complete AI Business Solutions. All rights reserved.
          </p>
          <p className={`text-xs text-center sm:text-right ${isDark ? "text-white/25" : "text-[#6e6e73]/70"}`}>
            Real operational impact. Built for service businesses.
          </p>
        </div>
      </div>
    </footer>
  );
}
